import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-delete',
  templateUrl: './delete.component.html'
})
export class DeleteComponent {
  @Input() documentName: string;
  isModalOpen: boolean;

  @Output() readonly selected: EventEmitter<any> = new EventEmitter<any>();

  onSelect(): void {
    this.isModalOpen = true;
  }

  handleResponse(event: boolean): void {
    if (event) {
      this.selected.emit();
    }
    this.isModalOpen = false;
  }
}
